import { useCurrency, Currency } from "@/contexts/CurrencyContext";
import { cn } from "@/lib/utils";

const CurrencySelector = () => {
  const { currency, setCurrency } = useCurrency();

  const options: { value: Currency; label: string }[] = [
    { value: "USD", label: "$ USD" },
    { value: "EUR", label: "€ EUR" },
  ];

  return (
    <div className="flex items-center bg-secondary/50 rounded-full p-0.5 border border-border/50">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => setCurrency(option.value)}
          className={cn(
            "px-3 py-1.5 text-xs font-body font-medium rounded-full transition-all duration-200",
            currency === option.value
              ? "bg-glow-pink text-background shadow-[inset_0_0_12px_4px_hsl(350_100%_95%),0_0_8px_2px_hsl(350_100%_88%/0.4)]"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default CurrencySelector;
